import {
    ACTIVE_DELETE_PROPOSAL_PROFILE,
    ACTIVE_DELETE_PROFILE,
    ACTIVE_DELETE_CERTIFICATIONS,
    ACTIVE_DELETE_AWARDS,
    ACTIVE_DELETE_RESET,
} from './../actions/DeleteImageAction';

const initialState = {
    deleteImg: {
        proposalImgProfile: false,
        imgProfile: false,
        certifications: [],
        awards: [],
    }
}

const DeleteImageReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTIVE_DELETE_PROPOSAL_PROFILE:
            return {
                ...state,
                deleteImg: {
                    ...state.deleteImg,
                    proposalImgProfile: action.data
                }
            }
        case ACTIVE_DELETE_PROFILE:
            return {
                ...state,
                deleteImg: {
                    ...state.deleteImg,
                    imgProfile: action.data
                }
            }
        case ACTIVE_DELETE_CERTIFICATIONS:
            state.deleteImg.certifications[action.data.index] = action.data.boolCancel
            return {
                ...state,
                deleteImg: {
                    ...state.deleteImg,
                    certifications: [
                        ...state.deleteImg.certifications,
                    ]
                }
            };
        case ACTIVE_DELETE_AWARDS:
            state.deleteImg.awards[action.data.index] = action.data.boolCancel
            return {
                ...state,
                deleteImg: {
                    ...state.deleteImg,
                    awards: [
                        ...state.deleteImg.awards,
                    ]
                }
            }
        case ACTIVE_DELETE_RESET:
            return {
                ...state,
                deleteImg: {
                    proposalImgProfile: false,
                    imgProfile: false,
                    certifications: [],
                    awards: [],
                }
            };
        default:
            return state;
    }
}
export default DeleteImageReducer;

